import React from 'react';
import { Modal } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import './ModalVideo.css';

export default (props) => {
  const {
    show,
    handleClose,
    url,
    ...rest
  } = props;
  return (
    <Modal
      className="modal-video"
      show={show}
      onHide={handleClose}
    >
      <div
        role="presentation"
        onClick={handleClose}
        className="close-icon"
      />
      <ReactPlayer
        url={url}
        config={{
          vimeo: {
            playerOptions: {
              title: false,
              portrait: false,
            },
            preload: true,
          },
        }}
        style={{
          margin: '0 auto',
          backgroundColor: 'transparent',
        }}
        {...rest}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ModalVideo.js